import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import EmptyState from "@/components/EmptyState";
import { CheckCircle2, XCircle, Mail } from "lucide-react";
import { Skeleton } from "@/components/ui/skeleton";

export default function History() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/sent-log").then((r) => {
      setRows(r.data);
      setLoading(false);
    });
  }, []);

  return (
    <div className="p-8 lg:p-12 max-w-4xl">
      <div className="mb-8">
        <div className="text-[11px] uppercase tracking-[0.25em] text-cyan-400 font-bold mb-2">Aktywność</div>
        <h1 className="font-display text-4xl font-semibold tracking-tight text-slate-50">Historia wysyłek</h1>
        <p className="text-slate-400 mt-2 text-sm">Dzienne digesty wysłane na Gmail.</p>
      </div>

      {loading ? (
        <div className="space-y-3">
          {[0, 1, 2].map((i) => (
            <Skeleton key={i} className="h-[80px] bg-slate-900/60" />
          ))}
        </div>
      ) : rows.length === 0 ? (
        <EmptyState
          testid="history-empty"
          title="Brak historii wysyłek"
          description="Skonfiguruj Gmail w Ustawieniach i wyślij pierwszy digest."
        />
      ) : (
        <div className="rounded-xl border border-slate-800 bg-slate-900/50 divide-y divide-slate-800 overflow-hidden">
          {rows.map((r) => (
            <div key={r.id} className="p-4 flex items-center gap-4" data-testid={`history-row-${r.id}`}>
              <div
                className={`w-9 h-9 rounded-lg flex items-center justify-center ${
                  r.success ? "bg-emerald-500/10 text-emerald-400" : "bg-red-500/10 text-red-400"
                }`}
              >
                {r.success ? <CheckCircle2 className="w-4 h-4" /> : <XCircle className="w-4 h-4" />}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 text-sm text-slate-200">
                  <Mail className="w-3.5 h-3.5 text-slate-500" />
                  <span className="truncate">{r.to_email || "—"}</span>
                  <span className="text-xs text-slate-500">·</span>
                  <span className="text-cyan-400 text-xs">{r.offer_count} ofert</span>
                </div>
                <div className="text-xs text-slate-500 mt-0.5">{new Date(r.sent_at).toLocaleString("pl-PL")}</div>
                {r.error && <div className="text-xs text-red-400 mt-1">{r.error}</div>}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
